import { AiIcon } from '@components/ui/ai-icon';
import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar';
import { getUserInitials } from '@utils/user-utils';

type UserAvatarProps = {
  /** Whose initials to show (`getUserInitials`: first + last initial). */
  user?: Parameters<typeof getUserInitials>[0];
  /** Initials computed by the caller; used instead of `user`. */
  initials?: string;
  /** An AI agent: shows the AI mark instead of initials. */
  agent?: boolean;
  /** Photo; the initials show until it loads, or if it fails. */
  imageUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
  /** Size of the AI mark for agents. */
  iconClassName?: string;
  'aria-hidden'?: boolean;
};

/** Round avatar: photo when there is one, otherwise initials or the AI mark. */
export function UserAvatar({
  user,
  initials,
  agent = false,
  imageUrl,
  className,
  fallbackClassName,
  iconClassName,
  'aria-hidden': ariaHidden
}: UserAvatarProps) {
  return (
    <Avatar className={className} aria-hidden={ariaHidden}>
      {imageUrl ? <AvatarImage src={imageUrl} alt="" /> : null}
      <AvatarFallback className={fallbackClassName}>
        {agent ? (
          <AiIcon className={iconClassName} />
        ) : (
          (initials ?? getUserInitials(user ?? {}))
        )}
      </AvatarFallback>
    </Avatar>
  );
}
